import { gql, useMutation } from '@apollo/client';

const REGENERATE_AUDIT_POLICY_SNIPPET = gql`
  mutation RegenerateAuditPolicySnippet($description: String!) {
    regenerateAuditPolicySnippet(description: $description)
  }
`;

export interface RegenerateAuditPolicySnippetVariables {
  description: string;
}

export interface RegenerateAuditPolicySnippetData {
  regenerateAuditPolicySnippet: string;
}

export function useRegenerateAuditPolicySnippetMutation() {
  return useMutation<RegenerateAuditPolicySnippetData, RegenerateAuditPolicySnippetVariables>(
    REGENERATE_AUDIT_POLICY_SNIPPET
  );
}
